export default __webpack_public_path__ + "static/media/name.8ce30078.svg";